























































































import { Vue, Component, Prop } from 'vue-property-decorator';
import MenuData from '@/data/Menu';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import LanguageButton from '@/components/LanguageButton.vue';
import DocumentButton from '@/components/DocDownload.vue';
import utils from '@/services/utils';

@Component({
  components: {
    LanguageButton,
    DocumentButton,
  },
})
export default class Sidebar extends Vue {
  @Prop() readonly toggleSidebar!: Function;

  AuthInstance = getModule(AuthModule, this.$store);

  utilsInstance = utils;

  menuList = MenuData.menuList;

  currentChild = null;

  async created() {
    this.menuList = await this.menuList
      .filter((item: any) => this.AuthInstance.user.userPermission[item.key] !== 'off'
        && item.allow
        && item.allow.includes(this.AuthInstance.user.role));
    await this.menuList.forEach((item: any, index) => {
      if (item.child) {
        const allowItem = item.child
          .filter((i: any) => ((i.allow
            && i.allow.includes(this.AuthInstance.user.role))
            && (!i.isEditPermKey
            || this.AuthInstance.user.userPermission[i.isEditPermKey] === 'edit')
            && (!i.level || i.level >= this.AuthInstance.user.level)
          ));
        this.menuList[index].child = allowItem;
      }
    });
  }

  closeSidebar() {
    this.toggleSidebar();
  }

  toggleChild(idx) {
    this.currentChild = idx !== this.currentChild ? idx : null;
  }

  async onLogout() {
    await this.AuthInstance.Logout();
    this.$router.push('/login');
  }
}
